import * as React from "react";
import { forwardRef } from "react";
const ArrowRightSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M12.664 3.253a1 1 0 0 0-1.328 1.494L18.37 11H3a1 1 0 1 0 0 2h15.37l-7.034 6.253a1 1 0 0 0 1.328 1.494l9-8a1 1 0 0 0 0-1.494z" }));
const ForwardRef = forwardRef(ArrowRightSVG);
export default ForwardRef;
//# sourceMappingURL=ArrowRight.js.map